<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-item-shop-product-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ItemShopProduct} from "@/modules/redactor/models/item-shop/ItemShopProduct";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RItemShopProductTable from "@/modules/redactor/views/item-shop/r-item-shop-product-table.vue";

export default {
  name: "r-item-shop-product-panel",
  components: {RItemShopProductTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Products"),
    items: VueTypes.arrayOf(ItemShopProduct)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>